<template>
	<div class="intent-item" :class="{'edit': isEdit}">
		<div class="container-fluid">
			<div>
				<a href="javascript:void(0);" @click="toggleDetail">
				<div class="header row" >
					<div class="col-xs-10" >
						
						<span style="margin-right:5px;margin-bottom: 10px;">{{intent.intentname}}</span>
						<!-- <div class="hidden-sm hidden-md hidden-lg" style="padding-top:5px" ></div>  -->
						<div class="visible-xs">
							<br>
						</div>
						<div style="display: inline-block" @click.stop>
							<div class="btn btn-primary btn-xs transparent" v-if="!isEdit" @click="isEdit = true;showDetail = true" style="margin-bottom:5px;"><i class="fas fa-pencil-alt"></i> <span class="hidden-xs">Edit</span></div>
							<div class="btn btn-primary btn-xs transparent" v-if="!isEdit && intent.intentname != '{default}'" @click="onCopyMyIntent()" style="margin-left:5px;margin-bottom: 5px;" ><i class="fa fa-copy middle"></i> <span class="hidden-xs">Copy</span></div>
							<div class="btn btn-primary btn-xs transparent" v-if="!isEdit" @click="showPreview = true" style="margin-left:5px;margin-bottom:5px;"><i class="glyphicon glyphicon-eye-open middle"></i> <span class="hidden-xs">Preview</span></div>
							<div class="btn btn-gray btn-xs transparent" v-if="!isEdit && intent.intentname != '{default}'" style="margin-left:5px;margin-bottom: 5px;" @click="$emit('onDelete')"><i class="fa fa-trash middle"></i> <span class="hidden-xs">Delete</span></div>
						</div>
					</div>
					<div class="col-xs-2 text-right">
						<template v-if="!isEdit">
							<span class="glyphicon " :class="{'glyphicon-chevron-down': showDetail, 'glyphicon-chevron-up' : !showDetail}"></span>
						</template>
					</div>
					
				</div>
				</a>

				<div v-if="isEdit || showDetail"  style="border-top:1px solid #eee;padding-top:15px;padding-bottom:15px;background: white;">
					<div class="row" v-if="isEdit">
						<div class="col-xs-12">
							<manage-intent :type="'edit'" v-model="intent" @close="onClose" :isDefault="intent.intentname == '{default}'" :excludedIntentName="excludedIntentName"></manage-intent>
						</div>
					</div>
					
					<div class="row" v-else>
						<div class="col-sm-6">
							<div class="question">
								<p class="small" >Question</p>
								<ul class="tags">
									<li class="tag" v-for="(question,index) in questions" :key="'question_'+index"><specialtext :text="question"></specialtext></li>	
								</ul>	
								<template v-if="intent.intentname == '{default}'">
									-
								</template>
							</div>

							<template v-if="intent.context_in == 'comment'">  
								<span class="glyphicon glyphicon-ok-sign"></span> Comment Reply
							</template>
						</div>
						<div class="col-sm-6">
							<div class="answer">
								<p class="small" >Answer</p>
								<template v-if="intent.a_type == 'text'">
									<div style="overflow-x: auto">
										<div style="display: flex;flex-direction: row">
											<div v-for="(answer,index) in answers" :key="'answer_'+index" style="margin-bottom: 5px;flex-grow: 1;  padding: 0px 10px;min-width: 300px" :style="{'border-right': answers.length > 1 ? '1px dashed #eee' : ''}">
												<div v-for="(message,mindex) in answer" :key="'message_'+mindex" >
													<template v-if="message.type == 'text'">

													<div class="message" style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;">
														<div style="font-size: 12px;color:black">
															<div style="padding: 5px 8px 6px;background-color:#F1F0F0">
																<span style="line-height:15.36px;"><specialtext :text="message.value.text"></specialtext></span>
															</div>
														</div>
														<div class="clearfix"></div>
														<div v-if="message.value.buttons.length > 0" style="float:left;width: 100%;border: 1px solid #eee; border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;overflow: hidden">
															<ul class="list-group list-group-flush" style="margin-bottom: 0px;" >
																<li class="list-group-item" style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 2px 15px" v-for="(button,bindex) in message.value.buttons" :key="bindex" :style="{'border-top': bindex != 0 ? '1px solid #eee' : 'none'}">
																	<span style="color: #0084FF">{{ button.title }}</span>
																	<p style="margin: 0;font-size: 10px;">
																		<template v-if="button.type == 'web_url'">{{button.url}}</template>
																		<template v-if="button.type == 'postback'">{{button.payload}}</template>
																	</p>
																</li>
															</ul>
														</div>
													</div>

												</template>
												<template v-else-if="message.type == 'image'">
													<div class="message" style="float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;">
														<div style="font-size: 12px;color:black">
															<img :src="message.value" alt="" style="width: 100%">
														</div>
													</div>
												</template>
													<div class="clearfix"></div>

												</div>
											</div>	
										</div>			
									</div>	
								</template>
								<template v-else-if="intent.a_type == 'template'">	
									<generic-viewer v-model="answers"></generic-viewer>				
								</template>
								<template v-else-if="intent.a_type == 'message' || intent.a_type == 'generic'">
									<intent-getstarted v-model="welcomemessage"></intent-getstarted>
								</template>
								<template v-else-if="intent.a_type == 'viewsummary'">
									<view-cart-summary-viewer></view-cart-summary-viewer>
								</template>
								<template v-else-if="intent.a_type == 'none'">
									No Reply
								</template>

								
								<template v-if="intent.a_type != 'none'">
									<div v-if="intent.a_type != 'message' && intent.a_type != 'generic' && intent.a_type != 'viewsummary'">
										<p class="small" style="margin-top: 10px">Quick Replies</p>
										<div class="quickreply">
											<template v-if="replies.length > 0">
												<ul class="tags">
													<li class="tag" v-for="(reply,index) in replies" :key="'reply_'+index">{{reply}}</li>	
												</ul>
											</template>
											<template v-else>
												-
											</template>
										</div>
									</div>
								</template>
							</div>
						</div>

						<div class="col-sm-12">

							<template v-if="intent.context_in || intent.context_out">
								<hr>
								<div class="row">
									<div class="col-sm-6">
										<p class="small">Context In</p>
										<p>
											{{intent.context_in ? intent.context_in : '-'}}
										</p>
									</div>
									<div class="col-sm-6">
										<p class="small">Context Out</p>
										<p>
											{{intent.context_out ? intent.context_out : '-'}}
										</p>
									</div>
								</div>
							</template>
						</div>
					</div>


				</div>
				
			</div>
			<!--  -->
			
		</div>

		<modal-dialog v-if="showPreview" @close="showPreview = false">
			<div slot="header">Preview</div>

			<div slot="body">
				<div  style="border: 1px solid #eee;padding: 20px 0px;background: #6b6b6b">
					<!-- <h3 style="text-align: center; color:white">Preview</h3> -->
					<facebook-screen :pagename="selectedBot.pagename" style="overflow-x: auto;padding: 15px">
						<div slot="body" style="position: relative;">
							<div >
								
								<div class="message" style="margin-left: 5px;margin-bottom: 10px;float:right;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;">
									<div style="font-size: 12px;color:white">
										<div style="padding: 5px 8px 6px;background-color:#3578e5">
											<span style="line-height:15.36px;"><specialtext :text="intent.intentname"></specialtext></span>
										</div>
									</div>
								</div>

								<div class="clearfix"></div>

							</div>

							<div style="min-height: 200px" v-if="intent.a_type != 'none'">
								<img :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=300&height=300'" alt="" style="width: 28px; height: 28px;border: 1px solid #eee;border-radius: 50%; float: left;margin-right: 5px;">
								<div style="overflow: auto;">
									<template v-if="intent.a_type == 'text'">
										<message-viewer v-model="intent.a_val"></message-viewer>
															
									</template>
									<template v-else-if="intent.a_type == 'template'">	
										<generic-viewer v-model="answers"></generic-viewer>				
									</template>
									<template v-else-if="intent.a_type == 'message' || intent.a_type == 'generic'">
										<intent-getstarted v-model="welcomemessage"></intent-getstarted>
									</template>
									<template v-else-if="intent.a_type == 'viewsummary'">
										<view-cart-summary-viewer></view-cart-summary-viewer>
									</template>

								</div>

							</div>
							
						</div>
						<div slot="quick_reply" v-if="replies" style="position:relative">
							<div style="padding-bottom: 30px"></div>
							<template v-if="intent.a_type != 'message' && intent.a_type != 'generic' && intent.a_type != 'viewsummary'">
							<div style="padding-top: 10px;padding-bottom: 10px;margin: auto;width: 100%;text-align:center;position: absolute; bottom: 0;overflow-x: auto; overflow-y: hidden;height: 40px;white-space: nowrap;">
								<ul style="margin: auto;padding: 0">
									<li v-for="(reply, index) in replies" :key="'reply_'+index" style="list-style-type: none;display:inline;padding: 5px 10px;border: 1px solid #0284ff;margin-right: 5px;border-radius: 20px;color:#0284ff;">
										{{reply}}
									</li>
								</ul>

							</div>
							</template>
							<template v-else>
								<div style="padding-top: 10px;padding-bottom: 10px;margin: auto;width: 100%;text-align:center;position: absolute; bottom: 0;overflow-x: auto; overflow-y: hidden;height: 40px;white-space: nowrap;">
									<ul style="margin: auto;padding: 0">
										<li v-for="(reply, index) in welcomemessage.quick_reply" :key="'reply_'+index" style="list-style-type: none;display:inline;padding: 5px 10px;border: 1px solid #0284ff;margin-right: 5px;border-radius: 20px;color:#0284ff;">
											{{reply}}
										</li>
									</ul>
								</div>
							</template>
						</div>
						<div slot="footer" style="border-top: 1px solid #eee">
							<img src="/static/img/assets/facebook_ui/iOS Composer Default.png" class="img-responsive" alt="">
						</div>
					</facebook-screen>

				</div>
			</div>

			<div slot="footer">
				<a href="javascript:void(0);" class="btn btn-primary" @click="showPreview = false">Close</a>
			</div>
		</modal-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage';
import specialtext from '@/components/elements/specialtext'
import IntentGetstarted from './IntentGetstarted'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import ModalDialog from '@/components/elements/ModalDialog'
import FacebookScreen from '@/components/elements/FacebookScreen'
import api from '@/api'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'

	export default{
		props: [
			'value',
			'excludedIntentName'
			],
		data: function(){
			return {
				isEdit: false,
				intent: this.value,
				showDetail: false,
				showPreview: false,
			}
		},
		mounted: function(){
			this.showDetail = this.intent.isShow
		},
		components: {
			'manage-intent' : manageIntent,
			specialtext,
			IntentGetstarted,
			GenericViewer,
			ModalDialog,
			FacebookScreen,
			MessageViewer,
			ViewCartSummaryViewer
		},
		computed: {
			...mapGetters({
				selectedBot: 'selectedBot',
				welcomemessage: 'welcomeMessage'
			}),
			questions: function(){
				if (this.intent.q_val != '') {
					return this.intent.q_val.split(",");
				} else {
					return '';
				}
			},
			answers: function(){
				var vm = this
				if (vm.intent.a_val != '' && vm.intent.a_type == 'text') {
					var newGroup = []
					var group_messages = vm.intent.a_val.split('||')
					$.each(group_messages,function(index, group){
						var messages = group.split('#nl')
						var newMessages = []
						$.each(messages, function(inedx, message){
							if (vm.isURL(message)) {
								newMessages.push(
									{
										type: 'image',
										value: message
									}
								)
							} else if(!isNaN(message)) {
								newMessages.push(
									{
										type: 'text',
										value: {
											text: message,
											buttons: []
										}
									}
								)
							} else if(vm.isJsonParseable(message)) {
								newMessages.push(
									{
										type: 'text',
										value: JSON.parse(message)
									}
								)
							} else {
								newMessages.push(
									{
										type: 'text',
										value: {
											text: message,
											buttons: []
										}
									}
								)
							}
						})
						newGroup.push(newMessages)
					})

					return newGroup
				} else if(vm.intent.a_type == 'template') {
					if (vm.isJsonParseable(vm.intent.a_val)) {
						return JSON.parse(vm.intent.a_val)
					} else {
						return []
					}
				}
			},
			replies: function(){
				var vm = this
				if (vm.intent.quick_reply != '' && vm.intent.quick_reply != null) {
					var replies = vm.intent.quick_reply.split(',')
					return replies
				} else {
					return []
				}
			},
			onCopyMyIntent: function(){
				let vm = this
				let data = {
					pageid: vm.selectedBot.pageid,
					intentname: vm.intent.intentname + " Copy",
					q_type : vm.intent.q_type,
					q_val : vm.intent.q_val,
					a_type: vm.intent.a_type,
					a_val: vm.intent.a_val,
					context_in: vm.intent.context_in,
					context_out: vm.intent.context_out,
					quick_reply: vm.intent.quick_reply,
				}
				if (confirm("Do you want to copy "+ data.intentname)) {
					vm.$store.dispatch('loading')
					api.addIntent(data,function(error, response){
						if (error) {
							console.error(error)
							vm.$store.dispatch('loading')
							return
						}
						data.id = response.id
						vm.$emit('onCopyIntent',data)
						vm.$store.dispatch('loading')
					})
					
				}
				
			},
		},
		methods: {
            isNumber: function(str) {
                try {
					parseFloat(str);
					console.log(parseFloat(str))
				} catch (e) {
					return false;
				}
				return true
            },
			isJsonParseable: function(str){
				try {
					JSON.parse(str);
				} catch (e) {
					return false;
				}
				return true
			},
			onClose: function(payload){
				this.isEdit = false
			},
			toggleDetail: function(){
				if(!this.isEdit)
					this.showDetail = !this.showDetail
			},
			isURL: function(str) {
                var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                '(\\:\\d+)?'+ // port
                '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
                '(\\?[;&a-z\\d%@_.,~+&:=-{}()]*)?'+ // query string
                '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                return pattern.test(str);
            },
            isNumber: function(str) {
                try {
                    parseFloat(str);
				} catch (e) {
					return false;
				}
				return true
            },
		},
		watch: {
			value : function(newVal, oldVal) {
				this.intent = newVal
				this.showDetail = newVal.isShow
			},
			'value.isShow': function(newVal){
				this.showDetail = newVal
			},
			intent: function(newVal){
				this.$emit('onUpdate',newVal)
				// this.intent = Object.assign({},newVal)
			} 
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/view/intent/intent-item.vue